<template>
  <div>
    <div class="jy-line-header">
      <div class="jy-line-active">{{ title }}</div>
      <div class="jy-line-ffaicon">
        <font-awesome-icon @click="onAngleDouble(0)" :icon="['fas', 'angle-double-up']" v-if="show" />
        <font-awesome-icon @click="onAngleDouble(1)" :icon="['fas', 'angle-double-down']" v-else />
      </div>
    </div>
    <div class="jy-line-body" v-show="show">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AngleDouble",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    onAngleDouble(type) {
      if(type === 0){
        this.show = false
      }else{
        this.show = true
      }
    }
  }
};
</script>
